import {API_URLS} from '@/const/urls';
import {http} from '@/helper';

export const premiumApi = {
  getUserTasks() {
    return http.get(API_URLS.USER_TASKS, {});
  },
  getSupportCurrency() {
    return http.get(API_URLS.SUPPORT_CURRENCY, {});
  },
  getPurchasePlans() {
    return http.get(API_URLS.MEMBERSHIP_PURCHASE_PLANS, {});
  },
  buyMembershipPurchase(query) {
    return http.post(API_URLS.MEMBERSHIP_PURCHASE, {query});
  },
  getUserKycInfo() {
    return http.get(API_URLS.USER_KYC_INFO, {});
  },
  getPrivilegeHistoryList(query) {
    return http.get(API_URLS.PREMIUM_PRIVILEGE_HISTORY_LIST, {query});
  },
  premiumLottery(params) {
    return http.post(API_URLS.PREMIUM_LOTTERY, {params});
  },
  getQualificationList(query) {
    return http.get(API_URLS.PREMIUM_QUALIFICATION_LIST, {query});
  },
  getPrivilegeDetails(query) {
    return http.get(API_URLS.PREMIUM_PRIVILEGE_DETAILS, {query});
  },
  getThirdPrivilegeInfo(query) {
    return http.get(API_URLS.PREMIUM_PRIVILEGE_THIRDPRIVILEGEINFO, {query});
  },
  getUserMember() {
    return http.get(API_URLS.PREMIUM_USER_MEMBER, {});
  },
  getGrowthConfig() {
    return http.get(API_URLS.PREMIUM_GROWTH_CONFIG, {});
  },
  getPremium() {
    return http.get(API_URLS.MEMBER_IS_PREMIUM, {});
  },
  getStage() {
    return http.get(API_URLS.MEMBER_STAGE, {});
  },
  getCouponsDetail(query) {
    return http.get(API_URLS.COUPON_DETAIL, {query});
  },
  getCouponsPrivilege(query) {
    return http.get(API_URLS.COUPON_PRIVILEGE, {query});
  },
  postCouponsExchange(params) {
    return http.post(API_URLS.COUPON_EXCHANGE, {params});
  },
  exchangePrivilege(params) {
    return http.post(API_URLS.PREMIUM_PRIVILEGE_EXCHANEGE, {params});
  },
  openAirPos(params) {
    return http.post(API_URLS.MARKETING_PRIVILEGE_USE, {params});
  },
};
